<mat-toolbar class="app-toolbar">
  <!-- Logo -->
  <a class="toolbar-logo" [routerLink]="['/secure']" aria-label="Home">
    <img src="assets/drx-logo-animated-white.svg" height="38px" alt="Draexlmaier logo" />
    <span class="toolbar-brand">D-PUSH</span>
  </a>

  <!-- Nav links — dynamic based on role -->
  <nav class="toolbar-nav">
    @if (admin()) {
      <a mat-button class="nav-link"
         [routerLink]="['/secure/administrator/applications']"
         routerLinkActive="nav-link--active">
        <mat-icon>apps</mat-icon>
        Applications
      </a>
      <a mat-button class="nav-link"
         [routerLink]="['/secure/administrator/tokens']"
         routerLinkActive="nav-link--active">
        <mat-icon>token</mat-icon>
        Tokens
      </a>
    } @else {
      <a mat-button class="nav-link"
         [routerLink]="['/secure/developer/applications']"
         routerLinkActive="nav-link--active">
        <mat-icon>apps</mat-icon>
        Applications
      </a>
    }
  </nav>

  <span class="toolbar-spacer"></span>

  <!-- User avatar + menu trigger -->
  <div class="toolbar-user">
    @if (username) {
      <span class="toolbar-username">{{ username }}</span>
    }
    <button mat-icon-button class="toolbar-menu-btn"
            [matMenuTriggerFor]="userMenu"
            aria-label="User menu">
      <div class="avatar">{{ avatarInitial }}</div>
    </button>
  </div>

  <mat-menu #userMenu="matMenu" xPosition="before">
    @if (username) {
      <div class="menu-user-info">
        <div class="menu-avatar">{{ avatarInitial }}</div>
        <div class="menu-user-details">
          <span class="menu-username">{{ username }}</span>
          <span class="menu-role">{{ admin() ? 'Administrator' : 'Developer' }}</span>
        </div>
      </div>
      <mat-divider></mat-divider>
    }
    @if (role) {
      <button mat-menu-item [routerLink]="'/spinner'">
        <mat-icon>swap_horiz</mat-icon>
        <span>Switch Role</span>
      </button>
    }
    <button mat-menu-item (click)="logout()">
      <mat-icon>logout</mat-icon>
      <span>Sign Out</span>
    </button>
  </mat-menu>
</mat-toolbar>
